module.exports = __webpack_public_path__ + "media/images/restaurante-4aca67d9f96093e2597c0136aa21826f.svg";